var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettingsFilled = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5395_119384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.645.586h-3.29l-.377 1.888c-.312.14-.61.312-.887.514L2.266 2.37.62 5.219 2.068 6.49c-.035.341-.035.684 0 1.025L.621 8.786l1.645 2.85 1.825-.618c.276.2.572.372.887.513l.377 1.888h3.29l.378-1.888c.312-.14.61-.312.887-.513l1.825.617 1.645-2.849-1.448-1.271a5.01 5.01 0 0 0 0-1.025L13.38 5.22l-1.645-2.85-1.825.618a4.958 4.958 0 0 0-.887-.513L8.645.586ZM7 9.336a2.333 2.333 0 1 1 0-4.667 2.333 2.333 0 0 1 0 4.667Z",
    fill: "#00D1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5395_119384"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgSettingsFilled;